import styled from '@emotion/styled'

export const StyledWrapper = styled.div`
  width: 900px;

  .valid_from,
  .valid_to {
    .item-content {
      width: 172px;
    }
  }
`
